export default __webpack_public_path__ + "images/0x3e6648c5a70a150a88bce65f4ad4d506fe15d2af.png";